import { render, staticRenderFns } from "./case-dialog.vue?vue&type=template&id=58bc0eb2&"
import script from "./case-dialog.vue?vue&type=script&lang=js&"
export * from "./case-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "case-dialog.vue"
export default component.exports